import React, { useState, useEffect } from "react";
import { Row, Col, Container } from "reactstrap";
import './Beasiswa.css';

const Beasiswa = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
      // Mencegah clickjacking dengan menghapus tampilan jika dalam iframe
      if (window.self !== window.top) {
          document.body.innerHTML = ''; 
      }
  }, []);

  const handleImageClick = (imageSrc) => {
    setSelectedImage(imageSrc);
  };

  const closeOverlay = () => {
    setSelectedImage(null);
  };

  const images = [
    "/beasiswa-asset/PMB-Januari-B1.jpg", 
    "/beasiswa-asset/PMB-Januari-B2.jpg", 
  ];

  return (
    <div className="beasiswa">
      {/* Header Section */}
      <header className="header-section">
        <div className="header-content">
          <h2>Beasiswa UPI YPTK</h2>
          <hr className="header-line" />
        </div>
      </header>

      <Container className="mt-4 gambar-beasiswa">
        <Row>
          {images.map((image, index) => (
            <Col md="3" key={index} className="mb-4">
              <img
                src={image}
                alt={`Poster Beasiswa ${index + 1} - UPI YPTK`}
                className="img-fluid"
                style={{ cursor: "pointer" }}
                onClick={() => handleImageClick(image)}
                loading="lazy"
                fetchpriority="low"
              />
            </Col>
          ))}
        </Row>
      </Container>

      {/* Overlay untuk gambar yang dipilih */}
      {selectedImage && (
        <div className="overlay" onClick={closeOverlay}>
          <img
            src={selectedImage}
            alt="Preview Beasiswa"
            className="overlay-image"
            loading="lazy"
            fetchpriority="high"
          />
        </div>
      )}
    </div>
  );
};

export default Beasiswa;
